//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { PrimaryLinkButton } from '@components/atoms/button/Button';
import {
  FilterOption,
  FilterValue,
} from '@components/media-filters/filterSectionModels';

interface ClearSelectionButtonProps<T extends FilterValue> {
  handleClearSection: (options: FilterOption<T>[]) => void;
  isDisabled?: boolean;
  options: FilterOption<T>[];
  trackingId?: string;
}

export const ClearSelectionButton = <T extends FilterValue>({
  handleClearSection,
  isDisabled,
  options,
  trackingId,
}: ClearSelectionButtonProps<T>) => {
  return (
    <PrimaryLinkButton
      isDisabled={isDisabled || !options.some(({ isSelected }) => isSelected)}
      onClick={() =>
        handleClearSection(
          options.map((option) => ({
            ...option,
            isSelected: false,
          })),
        )
      }
      trackingId={trackingId}
      type='button'
    >
      Clear Selection
    </PrimaryLinkButton>
  );
};
